(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const states = new WeakMap();
  const visible = new WeakMap();
  const play = (video) => { const attempt = video.play(); if (attempt) attempt.catch(() => {}); };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach(({target: video, isIntersecting}) => {
      visible.set(video, isIntersecting);
      if (isIntersecting && states.get(video)) play(video);
      else video.pause();
    });
  }, {threshold: 0.15}) : null;
  function setup(scope = document) {
    scope.querySelectorAll('[data-cc-video-container]').forEach((container) => {
      const video = container.querySelector('video');
      const button = container.querySelector('[data-cc-video-toggle]');
      if (!video || !button || states.has(video)) return;
      video.controls = false;
      video.removeAttribute('autoplay');
      video.muted = true;
      states.set(video, !reduceMotion.matches);
      const label = button.querySelector('[data-cc-video-label]');
      const sync = () => {
        const action = video.paused ? 'Play' : 'Pause';
        label.textContent = action;
        button.setAttribute('aria-label', `${action} video`);
      };
      button.hidden = false;
      button.addEventListener('click', () => {
        states.set(video, video.paused);
        if (video.paused) play(video); else video.pause();
      });
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      video.addEventListener('error', () => { button.hidden = true; });
      if (reduceMotion.matches) video.pause();
      sync();
      if (observer) observer.observe(video);
      else if (states.get(video)) play(video);
    });
  }
  reduceMotion.addEventListener('change', ({matches}) => {
    if (!matches) return;
    document.querySelectorAll('[data-cc-video-container] video').forEach((video) => {
      states.set(video, false);
      video.pause();
    });
  });
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('video').forEach((video) => { observer?.unobserve(video); video.pause(); });
  });
  setup();
})();
